import 'regenerator-runtime/runtime.js';

import { initSentry } from './lib/sentry';
import { App } from './App';
import { Globals } from './modules/Globals';
import axios from 'axios';

initSentry();

axios.defaults.withCredentials = true;

const app = new App();
// @ts-ignore
window.app = app;

try {
  navigator.serviceWorker
    .getRegistrations()
    .then(function (registrations) {
      for (let registration of registrations) {
        registration.unregister();
      }
    })
    .catch(function (err) {
      console.error('Service Worker unregistration failed: ', err);
    });
} catch (e) {
  console.error(e);
}
